import { addGETParams } from '../../config'
import ax from '../api'

/*
 * setBudget - Set a budget item on the server
 * @param {string} budgetId - The id of the budget item
 * @param {object} full - The full object of the budget item
 * @returns {object} The response from the server
 */
export const setBudget = async (budgetId, full) => {
	// Convert full object to JSON string
	const fullStr = JSON.stringify(full)

	// Send POST request with data in the body
	const _url = addGETParams(`/management/budget/set.php`, {
		budget_id: budgetId,
		full: fullStr
	})
	try {
		return await ax.post(_url)
	} catch (error) {
		console.error('Error in setSprint:', error)
		throw error
	}
}

/*
 * getBudgetList - Retrieve a list of budget items from the server
 * @param {object} params - Parameters to filter and paginate the budget list
 * @returns {object} The response from the server containing the list of budget
 */
export const getBudgetList = async (params) => {
	// console.log('params', params)
	// TODO: remove simulateApiCall, instead use  the actual API endpoint
	return simulateApiCall({
		data: {
			status: 'success',
			itms: [
				{
					budget_id: 'a1b2c3d4-e5f6-7g8h-9i10-j11k12l13m14',
					name: 'Budget 1',
					category_id: '1',
					budget_type: true,
					period_start: '2024-01-01',
					period_end: '2024-12-31',
					assigned_user_id: 'be5590fa-a0bd-4012-8680-f43cbf4c71bb',
					created_by: 'be5590fa-a0bd-4012-8680-f43cbf4c71bb',
					value: 1000,
					currency: 'usd',
					created_at: '2024-12-31',
					modified: '2024-12-31'
				},
				{
					budget_id: 'a1b2c3d4-e5f6-7g8h-9i10-j11k12l13m14s',
					name: 'Budget 2',
					category_id: '1',
					budget_type: false,
					period_start: '2024-01-01',
					period_end: '2024-12-31',
					assigned_user_id: '',
					created_by: 'be5590fa-a0bd-4012-8680-f43cbf4c71bb',
					value: 500,
					currency: 'usd',
					created_at: '2024-12-31',
					modified: '2024-12-31'
				}
			],
			nr: 1
		}
	})

	const _url = addGETParams(`/budget/lst.php`, params)

	return await ax.post(_url)
}

/*
 * getBudget - Retrieve a specific budget item from the server
 * @param {string} budget_id - The id of the budget item to retrieve
 * @returns {object} The response from the server containing the budget item
 */
export const getBudget = async (budget_id) => {
	// TODO: remove simulateApiCall, instead use  the actual API endpoint
	return simulateApiCall({
		status: 'success',
		data: {
			budget_id: 'a1b2c3d4-e5f6-7g8h-9i10-j11k12l13m14',
			name: 'Budget 1',
			category_id: '1',
			budget_type: 'in',
			period_start: '2024-01-01',
			period_end: '2024-12-31',
			assigned_user_id: 'be5590fa-a0bd-4012-8680-f43cbf4c71bb',
			created_by: 'be5590fa-a0bd-4012-8680-f43cbf4c71bb',
			value: 1000,
			currency: 'usd',
			created_at: '2024-12-31',
			modified: '2024-12-31'
		}
	})

	const _url = addGETParams(`/budget/get.php`, {
		budget_id
	})

	return await ax.post(_url)
}

// Mock API functions
/**
 * @function simulateApiCall
 * @description Utility function to simulate an API call with a delay, used for mocking.
 *
 * @param {object} data - The mock response data to return.
 * @returns {Promise<object>} A promise resolving the mock response after a short delay.
 */
const simulateApiCall = (data) => {
	return new Promise((resolve) => {
		// resolve(data)
		setTimeout(() => {
			resolve(data)
		}, 1000) // Simulate network delay
	})
}
